'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { mapObject } from 'underscore';
import { getLayoutData } from 'DesignData/selectors/layoutData';
import { MODULE_DATA_VALIDATION_HTML_FIELD_CONTAINS_HUBL } from 'DesignData/enums/CustomWidgetFieldErrorTypes';
const EMPTY_ARRAY = SeamlessImmutable([]);
export const getValidationErrorsById = (state, props) => state.hublValidator.templateErrorsById[props.assetId];
export const getLayoutValidationErrorsById = (state, props) => state.hublValidator.layoutErrorsById[props.layoutId];

const getLayoutWidgetId = (state, props) => props.sourceData.widgetId;

const getLayoutWidgetField = (state, props) => props.sourceData.widgetField;

export const getLayoutHeadErrors = createSelector([getLayoutValidationErrorsById], layoutValidationErrors => {
  return layoutValidationErrors && layoutValidationErrors.head || EMPTY_ARRAY;
});
export const getLayoutFooterErrors = createSelector([getLayoutValidationErrorsById], layoutValidationErrors => {
  return layoutValidationErrors && layoutValidationErrors.footer || EMPTY_ARRAY;
});
export const getLayoutWidgetsErrorsById = createSelector([getLayoutValidationErrorsById], layoutValidationErrors => {
  return layoutValidationErrors && layoutValidationErrors.widgets;
});
export const getLayoutWidgetsErrorsByIdWithLabels = createSelector([getLayoutWidgetsErrorsById, getLayoutData], (widgetsErrorsById, layoutData) => {
  if (!(widgetsErrorsById || layoutData)) return null;
  const widgetData = layoutData.widgets;
  return mapObject(widgetsErrorsById, (widgetError, widgetId) => {
    const label = widgetData[widgetId] ? widgetData[widgetId].label : '';
    return Object.assign({}, widgetError, {
      label
    });
  });
});
export const getLayoutWidgetFieldErrors = createSelector([getLayoutWidgetsErrorsById, getLayoutWidgetId, getLayoutWidgetField], (widgetsErrorsById, widgetId, field) => {
  if (!widgetsErrorsById) return [];
  const errorsForSelectedWidget = widgetsErrorsById && widgetsErrorsById[widgetId];
  if (!errorsForSelectedWidget) return EMPTY_ARRAY;
  return errorsForSelectedWidget[field] || EMPTY_ARRAY;
});
export const getLayoutWidgetHasValidatedField = createSelector([getLayoutWidgetsErrorsById, getLayoutWidgetId, getLayoutWidgetField], (widgetsErrorsById, widgetId, field) => {
  if (!widgetsErrorsById) return false;
  const errorsForSelectedWidget = widgetsErrorsById && widgetsErrorsById[widgetId];
  if (!errorsForSelectedWidget) return false;
  return Boolean(errorsForSelectedWidget[field]);
});
/**
 * This is CMv2 specific. HTML fields within module forms.
 */

export const makeGetLayoutWidgetHasValidatedHtmlFields = () => {
  return createSelector([getLayoutWidgetsErrorsById, getLayoutWidgetId], (widgetsErrorsById, widgetId) => {
    if (!widgetsErrorsById) return false;
    const errorsForSelectedWidget = widgetsErrorsById && widgetsErrorsById[widgetId];
    if (!errorsForSelectedWidget) return false;
    /* Optimistically assume that on first instance of validated field,
     * then all fields have been validated on mount */

    return Object.keys(errorsForSelectedWidget).some(fieldKey => {
      const fieldErrors = errorsForSelectedWidget[fieldKey];
      return fieldErrors.some(error => error.type === MODULE_DATA_VALIDATION_HTML_FIELD_CONTAINS_HUBL);
    });
  });
};